export type AiConfigTab =
  | 'domains'
  | 'generic-intents'
  | 'rag-categories'
  | 'prompt-templates';

const TAB_LABELS: Record<AiConfigTab, string> = {
  domains: 'Domain Profiles',
  'generic-intents': 'Generic Intents',
  'rag-categories': 'RAG Categories',
  'prompt-templates': 'Prompt Templates',
};

interface AiConfigTabBarProps {
  tab: AiConfigTab;
  onTabChange: (tab: AiConfigTab) => void;
  tabs?: AiConfigTab[];
}

export function AiConfigTabBar({ tab, onTabChange, tabs }: AiConfigTabBarProps) {
  const visibleTabs =
    tabs ??
    (['domains', 'generic-intents', 'rag-categories', 'prompt-templates'] as const);

  return (
    <div className="flex gap-2 mb-6 border-b border-gray-200">
      {visibleTabs.map((t) => (
        <button
          key={t}
          onClick={() => onTabChange(t)}
          className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${
            tab === t
              ? 'bg-white border border-b-0 border-gray-200 -mb-px text-blue-600'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
          }`}
        >
          {TAB_LABELS[t]}
        </button>
      ))}
    </div>
  );
}
